import { useEffect } from "react";
import { useInviteFriendModalStore } from "../../../js/stores/invite-friend-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { InviteFriendContent } from "./invite-friend-content";

function InviteFriendDialog({ isModalOpen, updateIsModalOpen }) {
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => updateIsModalOpen(false)}
      onOpenChange={updateIsModalOpen}
    >
      <DialogContent className="react-modal-content--narrow">
        <InviteFriendContent
          closeClickHandler={() => updateIsModalOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}

export function InviteFriendModal() {
  const isModalOpen = useInviteFriendModalStore((state) => state.isModalOpen);
  const updateIsModalOpen = useInviteFriendModalStore(
    (state) => state.updateIsModalOpen
  );

  useEffect(() => {

  }, []);

  return (
    <>
      {isModalOpen && (
        <InviteFriendDialog
          key={crypto?.randomUUID()}
          isModalOpen={isModalOpen}
          updateIsModalOpen={updateIsModalOpen}
        />
      )}
    </>
  );
}
